import { AxiosClient } from "@/app/shared/services";
import statisticsService from "@/app/admin/statistics/shared/statisticsService";

const state = {
    table: {
        isLoading: false,
        data: [],
        filters: {},
        grouping: [],
    },
};

const getters = {
    MONEY_STATISTICS_IS_LOADING: (state) => state.table.isLoading,
    MONEY_STATISTICS_DATA: (state) => state.table.data,
    MONEY_STATISTICS_GROUPING: (state) => state.table.grouping,
};

const mutations = {
    SET_MONEY_STATISTICS_IS_LOADING: (state, isLoading) => (state.table.isLoading = isLoading),
    SET_MONEY_STATISTICS_DATA: (state, data) => (state.table.data = data),
    SET_MONEY_STATISTICS_GROUPING: (state, grouping) => (state.table.grouping = grouping),
};

const actions = {
    FETCH_MONEY_STATISTICS: (context, params) => {
        return new Promise((resolve, reject) => {
            context.commit("SET_MONEY_STATISTICS_IS_LOADING", true);
            AxiosClient.post("/statistics/money-statistics", params)
                .then((response) => {
                    const statistics = statisticsService.parseMoneyStatistics(response.data);
                    const { data, grouping } = statistics;
                    context.commit("SET_MONEY_STATISTICS_DATA", data);
                    context.commit("SET_MONEY_STATISTICS_GROUPING", grouping);
                    resolve(statistics);
                })
                .catch(() => reject())
                .finally(() => context.commit("SET_MONEY_STATISTICS_IS_LOADING", false));
        });
    },
};

export default { state, getters, mutations, actions };
